

  /** text box calculator classe et sdg scolaire*/
  function totalPrice(el){

    var total = 0 
    var student = el.value;

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    total = (student * jQuery(el).attr("data-price"));
    jQuery(el).parents(".calculator").find(".totalPrice").html((Math.round(total * 100) / 100).toFixed(2)+'$')
    jQuery(el).parents(".calculator").find(".student-slider").val(student)

    if (student > 1000 ){
      jQuery(el).parents(".calculator").find(".student")
      jQuery(el).parents(".calculator").find(".totalPrice").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
    }
  }
  /** text box calculator sdg scolaire*/
  function totalPriceSDGS(el){
    
    var total = 0 
    var student = el.value;

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    if(student <= 200){

      jQuery(el).parents(".calculator").find(".student").attr('data-price','6.50')

    }
    if (student >= 201 ){

      jQuery(el).parents(".calculator").find(".student").attr('data-price','5.50')

    }
    if (student >= 401 ){

      jQuery(el).parents(".calculator").find(".student").attr('data-price','4.50')

    }

    total = (student * jQuery(el).attr("data-price"));
    jQuery(el).parents(".calculator").find(".totalPrice").html((Math.round(total * 100) / 100).toFixed(2)+'$')
    jQuery(el).parents(".calculator").find(".student-slider").val(student)

    
    if (student > 1000 ){
      jQuery(el).parents(".calculator").find(".student")
      jQuery(el).parents(".calculator").find(".totalPrice").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
    }
  }

      /**slider-box calculator */
  function totalPriceSliderSDGS(el){
    var student = el.value
    var total = 0 

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    total = (el.value * jQuery(el).attr("data-price-slider"));
    jQuery(el).parents(".calculator").find(".totalPrice").html((Math.round(total * 100) / 100).toFixed(2)+'$')
    jQuery(el).parents(".calculator").find(".student").val(el.value)

    if(student <= 200){
      jQuery(el).parents(".calculator").find(".student-slider").attr('data-price-slider','6.50')

    }
    if (student >= 201 ){
      jQuery(el).parents(".calculator").find(".student-slider").attr('data-price-slider','5.50')

    }
    if (student >= 401 ){
      jQuery(el).parents(".calculator").find(".student-slider").attr('data-price-slider','4.50')

    }
    if (student > 1000 ){       
      jQuery(el).parents(".calculator").find(".student-slider")
      jQuery(el).parents(".calculator").find(".totalPrice").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
    }


  }
  /** text box calculator AQUA*/
  function totalPriceAQUA(el){
    
    var total = 0 
    var student = el.value;

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    if(student <= 7500){
      jQuery(el).parents(".calculator").find(".student").attr('data-price','1.65')

    }
    if (student >= 7501 ){
      jQuery(el).parents(".calculator").find(".student").attr('data-price','1.60')

    }
   
    total = (student * jQuery(el).attr("data-price"));
    jQuery(el).parents(".calculator").find(".totalPrice").html((Math.round(total * 100) / 100).toFixed(2)+'$')
    jQuery(el).parents(".calculator").find(".student-slider").val(student)

    if (student > 15000 ){
      jQuery(el).parents(".calculator").find(".student")
      jQuery(el).parents(".calculator").find(".totalPrice").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
    }

  }

      /**slider-box calculator */
  function totalPriceSliderAQUA(el){
    var student = el.value
    var total = 0 

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    total = (el.value * jQuery(el).attr("data-price-slider"));
    jQuery(el).parents(".calculator").find(".totalPrice").html((Math.round(total * 100) / 100).toFixed(2)+'$')
    jQuery(el).parents(".calculator").find(".student").val(el.value)

    if(student <= 7500){
      jQuery(el).parents(".calculator").find(".student-slider").attr('data-price-slider','1.65')

    }
    if (student >= 7501 ){

      jQuery(el).parents(".calculator").find(".student-slider").attr('data-price-slider','1.60')

    }
   

    if (student > 15000 ){ 
      jQuery(el).parents(".calculator").find(".student-slider")
      jQuery(el).parents(".calculator").find(".totalPrice").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
    }

  }

    /**slider-box calculator */
  function totalPriceSlider(el){
    var student = el.value
    var total = 0 

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    total = (el.value * jQuery(el).attr("data-price-slider"));
    jQuery(el).parents(".calculator").find(".totalPrice").html((Math.round(total * 100) / 100).toFixed(2)+'$')
    jQuery(el).parents(".calculator").find(".student").val(el.value)

    if (student > 1000 ){
      jQuery(el).parents(".calculator").find(".student-slider")
      jQuery(el).parents(".calculator").find(".totalPrice").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
    }

  }

  /**camps de jour */
  /**standard */
  function totalPriceCamp(el){
  
    var totalCamp = 0
    var kids = el.value;

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    if(kids <= 99){

        jQuery(el).parents(".calculator").find(".kids").attr('data-price-camp','1.50')

    }
    if (kids >= 100 ){

      jQuery(el).parents(".calculator").find(".kids").attr('data-price-camp','1.25')

    }
    if (kids >= 501 ){

      jQuery(el).parents(".calculator").find(".kids").attr('data-price-camp','1.00')

    }
 
     /** else statement */
      totalCamp = (kids * jQuery(el).attr("data-price-camp"))
        jQuery(el).parents(".calculator").find(".kids-slider").val(kids)
        jQuery(el).parents(".calculator").find(".totalPriceCamp").html((Math.round(totalCamp * 100) / 100).toFixed(2)+'$')
        jQuery(el).parents(".calculator").find(".totalbox-camp p").css("display","block")
        jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeek").css("display","flex")

    if (kids >= 1001 ){
      
      jQuery(el).parents(".calculator").find(".kids").attr('data-price-camp','0')
      jQuery(el).parents(".calculator").find(".totalPriceCamp").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox-camp p").css("display","none")
      jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeek").css("display","none")
    }
  }

    /**slider-box calculator */
  function totalPriceSliderCamp(el){
    var kids = el.value;
    var totalCamp = 0 

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")
   
    if(kids <= 99){

      jQuery(el).parents(".calculator").find(".kids-slider").attr('data-price-slider-camp','1.50')

      }
      if (kids >= 100 ){
    
        jQuery(el).parents(".calculator").find(".kids-slider").attr('data-price-slider-camp','1.25')
      }
      if (kids >= 501 ){
        jQuery(el).parents(".calculator").find(".kids-slider").attr('data-price-slider-camp','1')

      }

        /** else statement */
        totalCamp = (el.value * jQuery(el).attr("data-price-slider-camp"));
        jQuery(el).parents(".calculator").find(".kids").val(el.value)
        jQuery(el).parents(".calculator").find(".totalPriceCamp").html((Math.round(totalCamp * 100) / 100).toFixed(2)+'$')
        jQuery(el).parents(".calculator").find(".totalbox-camp p").css("display","block")
        jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeek").css("display","flex")
      if (kids >= 1001 ){
        

        jQuery(el).parents(".calculator").find(".kids-slider").attr('data-price-camp','0')
        jQuery(el).parents(".calculator").find(".totalPriceCamp").html('<a href="/nous-joindre/">Contactez-nous!</a>')
        jQuery(el).parents(".calculator").find(".totalbox-camp p").css("display","none")
        jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeek").css("display","none")
      }
    
    }
    
  /**pro */
  function totalPriceCampPro(el){
    
    var totalCampPro = 0 
    var kids = el.value;

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

    if(kids <= 99){

        jQuery(el).parents(".calculator").find(".kids").attr('data-price-camp-pro','2.00')

    }
    if (kids >= 100 ){

      jQuery(el).parents(".calculator").find(".kids").attr('data-price-camp-pro','1.75')

    }
    if (kids >= 501 ){

      jQuery(el).parents(".calculator").find(".kids").attr('data-price-camp-pro','1.50')

    }

    /** else statement */
      totalCampPro = (kids * jQuery(el).attr("data-price-camp-pro"))
        jQuery(el).parents(".calculator").find(".kids-slider-pro").val(kids)
        jQuery(el).parents(".calculator").find(".totalPriceCampPro").html((Math.round(totalCampPro * 100) / 100).toFixed(2)+'$')
        jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeekPro").css("display","flex")
    if (kids >= 1001 ){
      
      jQuery(el).parents(".calculator").find(".kids-pro").attr('data-price-camp-pro','0')
      jQuery(el).parents(".calculator").find(".totalPriceCampPro").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
      jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeekPro").css("display","none")
    }

  }

  /**slider-box calculator */
  function totalPriceSliderCampPro(el){
    var kids = el.value;
    var totalCampPro = 0 

    jQuery(el).parents(".calculator").find(".totalbox p").css("display","block")

   if(kids <= 99){

    jQuery(el).parents(".calculator").find(".kids-slider").attr('data-price-slider-camp-pro','2.00')

    }
     if (kids >= 100 ){
  
      jQuery(el).parents(".calculator").find(".kids-slider").attr('data-price-slider-camp-pro','1.75')
    }
    if (kids >= 501 ){
      jQuery(el).parents(".calculator").find(".kids-slider").attr('data-price-slider-camp-pro','1.50')

    }

      /** else statement */
      totalCampPro = (el.value * jQuery(el).attr("data-price-slider-camp-pro"));
      jQuery(el).parents(".calculator").find(".kids-pro").val(el.value)
      jQuery(el).parents(".calculator").find(".totalPriceCampPro").html((Math.round(totalCampPro * 100) / 100).toFixed(2)+'$')
      jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeekPro").css("display","flex")
    if (kids >= 1001 ){

      jQuery(el).parents(".calculator").find(".kids-slider-pro").attr('data-price-camp-pro','0')
      jQuery(el).parents(".calculator").find(".totalPriceCampPro").html('<a href="/nous-joindre/">Contactez-nous!</a>')
      jQuery(el).parents(".calculator").find(".totalbox p").css("display","none")
      jQuery(el).parents(".calculator").find(".totalbox-camp .totalPriceWeekPro").css("display","none")
    }
  
    }


  function totalPriceWeek(el){
 
    var week =  jQuery(el).parents(".calculator").find(".week").val()

    var totalCamp =  jQuery(el).parents(".calculator").find(".totalPriceCamp").text().replace('$', '')

    var totalWeek = totalCamp * week

    jQuery(el).parents(".calculator").find(".totalPriceWeek").html('<p>Total :</p>'+(Math.round(totalWeek * 100) / 100).toFixed(2)+'$')

  }

  function totalPriceWeekPro(el){
    var week =  jQuery(el).parents(".calculator").find(".week").val()

    var totalCamp =  jQuery(el).parents(".calculator").find(".totalPriceCampPro").text().replace('$', '');

    var totalWeek = totalCamp * week
  
    jQuery(el).parents(".calculator").find(".totalPriceWeekPro").html('<p>Total :</p>'+(Math.round(totalWeek * 100) / 100).toFixed(2)+'$')
 
  }

  function totalPriceSliderWeek(el){

    var week =  jQuery(el).parents(".calculator").find("week-slider").val(el.value)

    var totalCamp =  jQuery(el).parents(".calculator").find(".totalPriceCamp").text().replace('$', '')

    var totalWeek = totalCamp * week

    jQuery(el).parents(".calculator").find(".totalPriceWeek").html((Math.round(totalWeek * 100) / 100).toFixed(2)+'$')
   
  }



  


